import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { userOrdersReselector as stateSelector } from 'reduxModules/users/selectors'
import { ordersDispatchers as dispatchSelector } from 'reduxModules/users/dispatchers'
import CollapsibleOrder from './CollapsibleOrder'
import './styles.css'

export class Orders extends Component {
  componentDidMount() {
    this.props.loadOrders()
    this.props.loadSubscriptions()
  }

  render() {
    if (!this.props.orders) return null
    const isEmpty = _.size(this.props.orders) === 0 && _.size(this.props.subscriptions) === 0
    return (
      <div
        className="account-section"
        id="Orders"
      >
        <h3 className="account-section__title">order history</h3>
        {_.size(this.props.subscriptions) > 0 && <h4>Subscriptions</h4>}
        {this.props.subscriptions && this.props.subscriptions.map((subscription, subscriptionIndex) => (
          <CollapsibleOrder
            key={subscriptionIndex}
            {...subscription}
            isMobile={this.props.isMobile}
            activeSubscription={this.props.subscription}
            isSubscription
          />
        ))}
        {_.size(this.props.orders) > 0 && <h4>Purchased items</h4>}
        {this.props.orders.length > 0 && (
          <div className="table-header">
            <div className="date">order date</div>
            <div className="order-id">order id</div>
            <div className="status">status</div>
            <div className="total">total</div>
          </div>
        )}
        {this.props.orders.map((order, orderIndex) => (
          <CollapsibleOrder
            key={orderIndex}
            {...order}
            isMobile={this.props.isMobile}
          />
        ))}
        {isEmpty && (
          <div className="no-results">
            <span>You don't have any orders yet.</span>
          </div>
        )}
      </div>
    )
  }
}

Orders.propTypes = {
  loadOrders: PropTypes.func.isRequired,
  loadSubscriptions: PropTypes.func.isRequired,
  orders: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool.isRequired,
  isSubscribed: PropTypes.bool.isRequired,
  loadSubscriptionTransactions: PropTypes.func,
  subscription: PropTypes.shape({
    active: PropTypes.bool,
    braintreeId: PropTypes.string,
    free: PropTypes.bool,
    id: PropTypes.number,
    plan: PropTypes.string
  }),
  subscriptionTransaction: PropTypes.bool
}

Orders.defaultProps = {
  orders: [],
  subscription: null,
  subscriptionTransaction: false,
  loadSubscriptionTransactions: null
}

export default connect(
  stateSelector,
  dispatchSelector
)(Orders)
